import React, { Component } from 'react'
import moment from 'moment'

class UserDocumentsView extends Component {

    render() {

        let document = this.props.documentInfo;
        if (!document) {
            return null;
        }
        return (
            <div>
                <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Тип</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{document.documentType}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Номер</label>
                            <div className="form-element-data">
                                <div className="form-element-data-text">
                                    <p>{document.documentNumber}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Выдан</label>
                            <div className="form-element-data date">
                                <div className="form-element-data-text">
                                    <p>{moment(document.startDate).format("DD.MM.yyyy")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Срок действия</label>
                            <div className="form-element-data">
                                <div className="form-element-data-text">
                                    <p>{moment(document.endDate).format("DD.MM.yyyy")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-row-item">
                        <div className="form-element">
                            <label className="form-element-label" htmlFor="#">Орган, выдавший документ</label>
                            <div className="form-element-data">
                                <div className="form-element-data-text">
                                    <p>{document.authority?.label ? document.authority.label : document.authority}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default UserDocumentsView
